import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const Wrapper = styled.div<{ $isOpen?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  border: 1px solid
    ${({ $isOpen }) => ($isOpen ? COLORS.primary : COLORS.border)};
  border-radius: ${RADII.field};
  background: ${COLORS.surface};
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${({ $isOpen }) =>
      $isOpen ? COLORS.primary : COLORS.borderHover};
  }
`

export const UiLayer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
`

export const HexLabel = styled.span`
  flex: 1;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textPrimary};
  text-transform: uppercase;
  user-select: none;
`

const swatchEdgeShadow =
  '0 0 0 1px rgba(13, 22, 48, 0.12), inset 0 0 0 1px rgba(255, 255, 255, 0.22)'

export const SwatchPreview = styled.div<{ $color: string }>`
  width: 25px;
  height: 25px;
  margin-right: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  background-color: ${({ $color }) => $color};
  box-shadow: ${swatchEdgeShadow};
`
